import React from "react";

const NoDataMessage = () => (
  <div className="p-4 text-center">
    <div className="row">
      <div className="col-12">
        <i className="fa fa-info-circle fa-3x text-muted mb-3" aria-hidden="true" />
        <p className="text-muted mb-0">No data</p>
      </div>
    </div>
  </div>
);

export default NoDataMessage;



// WEBPACK FOOTER //
// ./components/NoDataMessage.js